var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Polygon_2",
    "data-name": "Polygon 2",
    transform: "translate(14) rotate(90)",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.132,1.519a1,1,0,0,1,1.736,0L15.145,12.5a1,1,0,0,1-.868,1.5H1.723a1,1,0,0,1-.868-1.5Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 8.000003814697266 4.031135559082031 L 3.446368217468262 11.99999523162842 L 12.55362892150879 11.99999523162842 L 8.000003814697266 4.031135559082031 M 7.999999523162842 1.015560150146484 C 8.338147163391113 1.015560150146484 8.676294326782227 1.183515548706055 8.868239402770996 1.519425392150879 L 15.14505958557129 12.50386524200439 C 15.52600955963135 13.1705150604248 15.04463958740234 13.99999523162842 14.27681922912598 13.99999523162842 L 1.723179817199707 13.99999523162842 C 0.9553594589233398 13.99999523162842 0.4739894866943359 13.1705150604248 0.8549394607543945 12.50386524200439 L 7.131759643554688 1.519425392150879 C 7.323704719543457 1.183515548706055 7.66185188293457 1.015560150146484 7.999999523162842 1.015560150146484 Z",
    stroke: "none",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIcon);
export default __webpack_public_path__ + "static/media/playIcon.cd635fbae2bfc27be761f3e40de302f1.svg";
export { ForwardRef as ReactComponent };